export enum Routes {
  // Terminal
  Terminal = '/pos',
  TerminalOrderCharge = '/pos/order/:id/charge',
  ExternalOrders = '/pos/external-orders',
  // Dashboard
  AdminDashboard = '/admin',
  AdminSettings = '/admin/settings',
  AdminCategoryList = '/admin/category/:id/list',
  AdminCategoryEdit = '/admin/category/:id/edit',
  AdminCategoryCreate = '/admin/category/:id/create',
  AdminItemList = '/admin/items',
  AdminOfferList = '/admin/offers',
  AdminItemEdit = '/admin/item/:id/edit',
  AdminItemCreate = '/admin/item/create',
  AdminTaxList = '/admin/taxes',
  AdminTaxEdit = '/admin/tax/:id/edit',
  AdminTaxCreate = '/admin/tax/create',
  // Users
  AdminUsersList = '/admin/users',
  AdminUserCreate = '/admin/user/create',
  AdminUserEdit = '/admin/user/:id/edit',
  // Inventory Management
  InventoryItemsList = '/admin/inventory/items',
  InventoryItemCreate = '/admin/inventory/item/create',
  InventoryItemEdit = '/admin/inventory/item/:id/edit',
  StockMovementsList = '/admin/inventory/movements',
  StockMovementCreate = '/admin/inventory/movement/create',
  RecipesList = '/admin/inventory/recipes',
  RecipeCreate = '/admin/inventory/recipe/create',
  RecipeEdit = '/admin/inventory/recipe/:id/edit',
  // Misc
  PageBadRequest = '/400',
  PageNotFound = '/404',
  //Orders
  OrdersList = '/admin/orders/list',
  //Cashier Closes
  CashierClosesList = '/admin/cashier-closes/list',
  //Sign
  SignIn = '/signin',
  SignUp = '/signup',
}
